import { Button } from '@mui/material'

import withStyles from '@mui/styles/withStyles'
import makeStyles from '@mui/styles/makeStyles'

export const StyledButton = withStyles(theme => ({
  root: {
    border: ({ invert }) =>
      invert ? `0.25rem solid rgba(255, 255, 255, 0.2)` : 'none',
    borderRadius: '2rem',
    boxSizing: 'border-box',
    height: 'auto',
    padding: ({ invert }) => (invert ? '0.75rem 0' : '1rem 0'),
    background: ({ invert }) =>
      invert
        ? 'none'
        : `linear-gradient(276deg, ${theme.gradient.button.start} 0%, ${theme.gradient.button.stop} 100%)`,
    fontSize: theme.size.base,
    color: theme.palette.altButtonText.main
  }
}))(Button)

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  children: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  loading: {
    marginLeft: '0.5rem'
  }
}))

export default useStyles
